import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DownloadIcon from "@mui/icons-material/Download";

const PageHeader = ({
  title,
  downloadLabel,
  iconDownloadLabel,
  onBack,
  onDownload,
  onIconDownload,
  downloadDisabled = false,
  iconDownloadDisabled = false,
}) => (
  <Box
    sx={{
      position: "relative",
      display: "flex",
      alignItems: "center",
      minHeight: 48,
    }}>
    <IconButton
      aria-label="Back"
      onClick={onBack}
      sx={{ position: "absolute", left: 0, color: "primary.main" }}>
      <ArrowBackIcon />
    </IconButton>
    <Typography
      variant="h5"
      sx={{
        color: "primary.main",
        flex: 1,
        fontWeight: 800,
        lineHeight: 1.2,
        px: { xs: 5, md: 24 },
        textAlign: "center",
        textTransform: "uppercase",
      }}>
      {title}
    </Typography>
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexShrink: 0,
        gap: 0.75,
        position: { xs: "static", sm: "absolute" },
        right: 0,
        whiteSpace: "nowrap",
      }}>
      {onIconDownload && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<DownloadIcon fontSize="small" />}
          aria-label={iconDownloadLabel}
          title={iconDownloadLabel}
          onClick={onIconDownload}
          disabled={iconDownloadDisabled}
          sx={{
            minHeight: 36,
            px: 1.5,
            "& .MuiButton-startIcon": {
              mr: 0.75,
            },
          }}>
          {iconDownloadLabel}
        </Button>
      )}
      <Button
        size="small"
        variant="contained"
        startIcon={<DownloadIcon fontSize="small" />}
        onClick={onDownload}
        disabled={downloadDisabled}
        sx={{
          minHeight: 36,
          minWidth: { xs: 36, sm: "auto" },
          px: { xs: 1, sm: 1.5 },
          "& .MuiButton-startIcon": {
            margin: 0,
            mr: { sm: 0.75 },
          },
        }}>
        <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
          {downloadLabel}
        </Box>
      </Button>
    </Box>
  </Box>
);

export default PageHeader;
